import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import s from './UserStatusIcon.css';

const UserStatusIcon = ({ away, online, whiteOfflineStatus, marginRight }) => (
  <div
    data-qa={`userStatusIcon-${online ? 'online' : away ? 'away' : 'offline'}`}
    className={classnames({
      [s.component]: true,
      [s.whiteOffline]: whiteOfflineStatus,
      [s.online]: online,
      [s.away]: away,
    })}
    style={marginRight && { marginRight }}
  >
    <div className={s.icon}/>
  </div>
);

UserStatusIcon.propTypes = {
  away: PropTypes.bool,               // Displays as away if true
  online: PropTypes.bool,             // Displays as online if true
  whiteOfflineStatus: PropTypes.bool, // The offline state border is white if true
  marginRight: PropTypes.string,      // Set a custom right margin
};

export default UserStatusIcon;
